import React from "react";
import { CreditCard, Smartphone, Wallet, Banknote } from "lucide-react";

const banks = ["BCA", "BNI", "BRI", "Mandiri", "CIMB", "Danamon", "Permata"];
const ewallets = ["DANA", "OVO", "GoPay", "LinkAja", "ShopeePay"];
const pulsa = ["Telkomsel", "XL", "Indosat", "Tri", "Smartfren"];

const Pill = ({ children, testid }) => (
    <span
        data-testid={testid}
        className="inline-flex items-center px-4 py-2 rounded-lg bg-[#0c0c0c] border border-white/10 text-sm text-white/80"
    >
        {children}
    </span>
);

export default function Payments() {
    return (
        <section
            data-testid="payments-section"
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="max-w-3xl">
                    <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                        Metode Transaksi
                    </span>
                    <h2 className="mt-4 text-3xl md:text-5xl font-medium tracking-tighter text-white">
                        Transaksi cepat untuk{" "}
                        <span className="text-gold-gradient">
                            hiburan online terpercaya
                        </span>
                    </h2>
                    <p className="mt-5 text-white/60 max-w-2xl">
                        Kami mendukung berbagai metode deposit dan withdraw — bank lokal,
                        e-wallet, hingga pulsa tanpa potongan — agar akses ke platform
                        hiburan digital tetap mulus.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
                    <div className="rounded-2xl border border-white/5 bg-[#0c0c0c] p-8">
                        <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37]">
                            <CreditCard size={20} />
                        </div>
                        <h3 className="mt-5 text-xl font-medium text-white">Bank Lokal</h3>
                        <div className="mt-5 flex flex-wrap gap-2">
                            {banks.map((b, i) => (
                                <Pill key={b} testid={`bank-${i}`}>
                                    {b}
                                </Pill>
                            ))}
                        </div>
                    </div>

                    <div className="rounded-2xl border border-white/5 bg-[#0c0c0c] p-8">
                        <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37]">
                            <Wallet size={20} />
                        </div>
                        <h3 className="mt-5 text-xl font-medium text-white">E-Wallet</h3>
                        <div className="mt-5 flex flex-wrap gap-2">
                            {ewallets.map((b, i) => (
                                <Pill key={b} testid={`ewallet-${i}`}>
                                    {b}
                                </Pill>
                            ))}
                        </div>
                    </div>

                    <div className="rounded-2xl border border-white/5 bg-[#0c0c0c] p-8">
                        <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37]">
                            <Smartphone size={20} />
                        </div>
                        <h3 className="mt-5 text-xl font-medium text-white">
                            Pulsa (Tanpa Potongan)
                        </h3>
                        <div className="mt-5 flex flex-wrap gap-2">
                            {pulsa.map((b, i) => (
                                <Pill key={b} testid={`pulsa-${i}`}>
                                    {b}
                                </Pill>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-10 flex items-center gap-3 text-xs text-white/40">
                    <Banknote size={14} className="text-[#D4AF37]" />
                    Deposit minimal rendah, tanpa biaya tersembunyi.
                </div>
            </div>
        </section>
    );
}
